var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 text-center",style:(_vm.styles)},[_c('beat-loader',{attrs:{"color":_vm.style.colorPrimary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }